document.addEventListener('DOMContentLoaded', () => {
  // menu
  const menu = document.querySelector('.js-menu')
  const menuOpenBtn = document.querySelector('.js-menu-open')
  const menuCloseBtn = document.querySelector('.js-menu-close')

  function closeMenu () {
    menu.classList.remove('open')
    document.body.classList.remove('overflow-hidden')
  }

  menuOpenBtn.addEventListener('click', (e) => {
    e.preventDefault()

    menu.classList.add('open')
    document.body.classList.add('overflow-hidden')
  })

  menuCloseBtn.addEventListener('click', (e) => {
    e.preventDefault()

    closeMenu()
  })

  // anchors
  const anchors = document.querySelectorAll('.js-nav-link')

  for (let anchor of anchors) {
    anchor.addEventListener('click', (e) => {
      e.preventDefault()

      const blockID = anchor.getAttribute('href')

      closeMenu()
      document.querySelector(blockID).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    })
  }

  //tabs
  function createIframeContainer (containerId, iframeName, src, mode, activityId) {
    const element = document.createElement('div')

    element.setAttribute('id', containerId)
    element.setAttribute('iframe-name', iframeName)
    element.setAttribute('src', src)
    element.setAttribute('mode', mode)
    element.setAttribute('activity-id', activityId)

    return element
  }

  const playerTabs = document.querySelectorAll('.js-player-tab')

  for (let playerTab of playerTabs) {
    playerTab.addEventListener('click', (e) => {
      e.preventDefault()
      if (e.target.classList.contains('active')) return

      const { containerId, iframeName, src, mode, activityId } = e.target.dataset
      const tabsContent = document.querySelector('.js-player-tabs-content')
      const newIframeContainer = createIframeContainer(containerId, iframeName, src, mode, activityId)

      tabsContent.innerHTML = ''
      tabsContent.append(newIframeContainer)
      window.initIframe(containerId)

      for (let tab of playerTabs) {
        tab.classList.remove('active')
      }

      e.target.classList.add('active')
    })
  }

  const scheduleTabs = document.querySelectorAll('.js-schedule-tab')

  for (let scheduleTab of scheduleTabs) {
    scheduleTab.addEventListener('click', (e) => {
      e.preventDefault()
      if (e.target.classList.contains('active')) return

      const { containerId, iframeName, src, mode, activityId } = e.target.dataset
      const tabsContent = document.querySelector('.js-schedule-tabs-content')
      const newIframeContainer = createIframeContainer(containerId, iframeName, src, mode, activityId)

      tabsContent.innerHTML = ''
      tabsContent.append(newIframeContainer)
      window.initIframe(containerId)

      for (let tab of scheduleTabs) {
        tab.classList.remove('active')
      }

      e.target.classList.add('active')
    })
  }

  // speakers
  const speakersWrapper = document.querySelector('.js-speakers-wrapper')
  const speakersList = document.querySelector('.js-speakers-list')
  const showSpeakersBtn = document.querySelector('.js-show-speakers')

  showSpeakersBtn.addEventListener('click', (e) => {
    e.preventDefault()

    if (e.target.classList.contains('active')) {
      speakersWrapper.style = ''
      e.target.classList.remove('active')
    } else {
      const listHeight = speakersList.offsetHeight
      speakersWrapper.style.height = `${listHeight}px`
      e.target.classList.add('active')
    }
  })

  window.addEventListener('resize', () => {
    if (showSpeakersBtn.classList.contains('active')) {
      speakersWrapper.style = ''
      showSpeakersBtn.classList.remove('active')
    }
  })
})
